import { render, staticRenderFns } from "./template.vue?vue&type=template&id=4b1db530&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./template.vue?vue&type=style&index=1&id=4b1db530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1db530",
  null
  
)

export default component.exports